import styled, { keyframes } from 'styled-components/macro';
import { Focusable } from 'components/navigation';
import scaleSize from 'utils/scale-size';
import LeftArrowIcon from 'components/Icons/arrow';

export const MIN_KEY_WIDTH = 90;
export const MARGIN_RIGHT = 10;

export const cursor = keyframes`
  0% {opacity: 0;}
  50% {opacity: 1;}
  100% {opacity: 0;}
`;

export const StyledKey = styled(Focusable)`
  width: ${({ span = 1 }) =>
    scaleSize(MIN_KEY_WIDTH * span + MARGIN_RIGHT * span - MARGIN_RIGHT)}px;
  height: ${scaleSize(60)}px;
  line-height: ${scaleSize(60)}px;
  text-align: center;
  border-radius: ${scaleSize(8)}px;
  background: ${({ theme }) => theme.backgroundColor};
  color: ${({ disabled, theme }) => (disabled ? theme.backgroundColor : theme.mainTextColor)};
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${({ smallFont }) => scaleSize(smallFont ? 32 : 40)}px;
  display: inline-block;
  font-weight: normal;
  margin-right: ${scaleSize(MARGIN_RIGHT)}px;
  box-sizing: border-box;

  & > svg path {
    fill: ${({ theme }) => theme.mainTextColor};
  }

  &:focus {
    background: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.focusedTextColor};

    & > svg path {
      fill: ${({ theme }) => theme.focusedTextColor};
    }
  }
`;

export const RightArrowIcon = styled(LeftArrowIcon)`
  transform: rotate(180deg);
`;

export const StyledLetter = styled.div`
  display: inline-block;
  margin-right: 1px;
  min-width: ${scaleSize(10)}px;
  text-align: center;
`;

export const StyledCursor = styled.div`
  display: inline-block;
  width: 2px;
  height: ${scaleSize(50)}px;
  vertical-align: middle;
  margin-top: -${scaleSize(4)}px;
  margin-left: -1px;
  background: ${({ theme }) => theme.mainTextColor};
  animation-name: ${cursor};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`;

export const Row = styled.div`
  margin-bottom: ${scaleSize(10)}px;
`;

export const StyledInput = styled.div`
  width: ${scaleSize(MIN_KEY_WIDTH * 11 + MARGIN_RIGHT * 10)}px;
  height: ${scaleSize(60)}px;
  display: inline-block;
  background: ${({ theme }) => theme.submenuActiveColor};
  margin-right: ${scaleSize(MARGIN_RIGHT)}px;
  border-radius: ${scaleSize(8)}px;
  box-sizing: border-box;
  line-height: ${scaleSize(60)}px;
  text-align: left;
  color: ${({ theme }) => theme.focusedTextColor};
  font-size: ${scaleSize(40)}px;
  padding: 0 ${scaleSize(20)}px;
`;
